import React from "react"
import { connect } from "react-redux"
import moment from "moment"
import { compose, defaultProps } from "recompact"
import eventTypeModel from "src/models/eventType"
import entityList from "src/hocs/entityList"
import EntityListEditor from "src/components/EntityListEditor"
import {
  EVENT_TYPE_CREATE,
  EVENT_TYPE_UPDATE,
  EVENT_TYPE_DELETE,
} from "src/constants/knownPermissions"
import { hasPermission } from "src/engine/modules/currentUser"
import queryString from "query-string"
import { EVENT_TYPES_URL } from "src/constants/routeNames"
import { makeTransparent, DEFAULT_COLOR } from "../Calendar/helpers/eventToItem"
import Item from "./Item"
import styles from "./styles.css"

const closeModal = ({ history, queryParams }) => () => {
  history.push(`${EVENT_TYPES_URL}?${queryString.stringify(queryParams)}`)
}

const getCaptionPart = (value, unitText) =>
  value > 0 ? value.toString().concat(unitText) : null

export const secondsToDaysHoursMinutes = seconds => {
  const duration = moment.duration(seconds * 1000)
  return [
    getCaptionPart(Math.floor(seconds / 86400), ` д.`),
    getCaptionPart(duration.hours(), ` ч.`),
    getCaptionPart(duration.minutes(), ` мин.`),
  ]
    .filter(element => element !== null)
    .join(`, `)
}

const columns = [
  {
    Header: `Наименование и цвет`,
    accessor: `name`,
    maxWidth: 265,
    sortable: true,
    Cell: ({ original: { color, name } }) => (
      <div>
        <span
          className={styles.circle}
          style={{
            backgroundColor: `${
              color === `#fff` ? DEFAULT_COLOR : makeTransparent(color, 0.4)
            }`,
          }}
        />
        <span className={styles.name}>{name}</span>
      </div>
    ),
  },
  {
    Header: `Мин. длительность события`,
    accessor: `minExecutionTime`,
    sortable: true,
    maxWidth: 240,
    Cell: ({ original: { minExecutionTime: seconds } }) => (
      <div>{secondsToDaysHoursMinutes(seconds)}</div>
    ),
  },
  {
    Header: `Макс. длительность события`,
    accessor: `maxExecutionTime`,
    maxWidth: 240,
    sortable: true,
    Cell: ({ original: { maxExecutionTime: seconds } }) => (
      <div>{secondsToDaysHoursMinutes(seconds)}</div>
    ),
  },
  {
    Header: `Длительность по умолчанию`,
    accessor: `defExecutionTime`,
    sortable: true,
    Cell: ({ original: { defExecutionTime: seconds } }) => (
      <div>{secondsToDaysHoursMinutes(seconds)}</div>
    ),
    resizable: false,
  },
]

const enhancer = compose(
  entityList({
    model: eventTypeModel,
    baseUri: EVENT_TYPES_URL,
    columns,
  }),
  defaultProps({
    EntityEditor: compose(
      defaultProps({
        onCreate: closeModal,
        onUpdate: closeModal,
      }),
      connect(state => ({
        disableEdit: !hasPermission(EVENT_TYPE_UPDATE)(state),
      })),
    )(Item),
    isOnlySearchInputFilter: true,
  }),
  connect(state => ({
    disableCreate: !hasPermission(EVENT_TYPE_CREATE)(state),
    disableEdit: !hasPermission(EVENT_TYPE_UPDATE)(state),
    disableDelete: !hasPermission(EVENT_TYPE_DELETE)(state),
  })),
)

export default enhancer(EntityListEditor)
